
<div class="row">
  <div class="card margin-left-14px width-802px">
    <div class="card-header wh-header header3 ">
      <div class="row">
        <div class="col-md-6 padding-right-0px">
          <label>Branch Map</label>
        </div>
        <div class="col-md-6 float-right text-align-end">
          <!--<button type="button" (click)="Addbranch()" class="btn btn-primary btn-sm nav-link-hand"><i class="fas fa-plus"></i></button>-->
          <a (click)="Editbranch()" class="nav-link-hand education-navlink">
            <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
          </a>
        </div>
      </div>
    </div>
    <div class="card-body padding-top-0px">
      <div class="table-component overflow-x">
        <div class="table-responsive overflow-x">


          <table class="table table-striped margin-left-zero">

            <thead class="">
              <tr>
               

                <th class="">Name</th>

                <th class="">Cost</th>
                <th></th>

              </tr>
            </thead>
            <tbody class="table-body">
              <tr>
               

                <td class="td-padding ">
                  Drug Administartion
                </td>
                
                <td class="td-padding ">
                  <!--<input type="number" class="form-control" [(ngModel)]="RequestedPositions"
                         readonly
                         min="1" max="10" />-->
                  100
                </td>


                <td><a><i class="far fa-trash-alt"></i></a></td>



              </tr>

            </tbody>

          </table>
        </div>
      </div>
    </div>
  </div>
</div>


